/* unplugin-vue-components disabled */import { render } from "./mg-flex-fill.vue?vue&type=template&id=39cda6e3"
const script = {}

import "./mg-flex-fill.vue?vue&type=style&index=0&id=39cda6e3&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__